import { Button, ButtonProps, Text } from '@mantine/core'
import { ReactNode } from 'react'

type Props = ButtonProps & {
  text?: string
  textSize?: string
  textColor?: string
  hoverBackground?: string
  border?: string
  onClick?: (e?: any) => void
  children?: ReactNode
}

function PrimaryButton({ text, textSize = '1.3em', textColor = 'white', onClick, children, hoverBackground = '#02136a', border = 'none', ...props }: Props) {
  return (
    <Button
      bg="#32439A"
      w="fit-content"
      miw={"120px"}
      h="4em"
      style={{ borderRadius: '4px' }}
      loading={props.loading}
      onClick={onClick}
      styles={{
        root: {
          border: border,
          '&:hover': {
            background: hoverBackground,
          },
        },
      }}
      {...props}
    >
      <Text
        color="#262626"
        fz={textSize}
        fw={600}
        style={{
          fontFamily: 'Plus Jakarta Sans',
          color: textColor,
        }}
      >
        {text ?? children}
      </Text>
    </Button>
  )
}

export default PrimaryButton
